import styles from './statistics-page.module.scss'
import cl from 'classnames'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'mobx-stores/store-provider'
import { useEffect, useState } from 'react'
import { getMainImageSrcForObj, IconStatistics, IconStores, ImagePortrait, PageContainer, PageHeader, PeriodPicker, RatingStars } from '@touche-lts/panel-ui/dist'
import {
  Chart,
  registerables
} from 'chart.js';
import { Chart as Customchart } from 'react-chartjs-2';
import { StatisticsTable } from 'pages'
import moment from 'moment'
import { StatisticsDatePeriod, StatisticsStores } from 'models/statistics'
import { PeriodValue } from '@touche-lts/panel-ui/dist/components/shared/date-range-picker'
import { StatisticsProps, } from './statistics-page.types'
import { StoreDTO } from 'models/store'
import { useGetIsResponsiveScreen } from 'hooks/custom-hooks'
import { formatNumberShort } from '../../utilities'

Chart.register(
  ...registerables
);

const StatisticsPageComponent = (props: StatisticsProps) => {
  let storeName = props?.location?.state?.storeName;
  let storeId = props?.location?.state?.storeId
  const {
    isDashboard,
  } = props,
    {
      statisticsStore: {
        getHighLights,
        statisticsHighlights,
        getGraphInfo,
        statisticsGraph,
        statiSticsGraphData,
        setPeriodDate,
        setCustomPeriod,
        getStores,
        storesList
      },
      statisticsTableStore: {
        setStoreSelected,
        triggerSearch,
        storeSelected,
      }
    } = useRootStore()

  const selectDatePeriod = (ev): void => {
    const targetValue = ev.target.value;
    let period = null;
    if (targetValue === StatisticsDatePeriod.WEEK) {
      period = moment().subtract(7, 'd').toDate().toISOString()
    } else if (targetValue === StatisticsDatePeriod.MONTH) {
      period = moment().subtract(1, 'months').toDate().toISOString()
    } else {
      period = moment().subtract(1, 'years').toDate().toISOString()
    }
    setPeriodDate(period)
    triggerSearch({ resetPageNumber: true })
    getGraphInfo(storeSelected)
    getHighLights(storeSelected)
    setStartPeriod(null)
    setEndPeriod(null)
  }

  const [startPeriod, setStartPeriod] = useState(null);
  const [endPeriod, setEndPeriod] = useState(null);

  const setPeriod = (period: PeriodValue) => {
    setStartPeriod(period ? period.start : null)
    setEndPeriod(period ? period.end : null)
    setCustomPeriod(period, storeSelected)
    triggerSearch({ resetPageNumber: true })
  }

  const handleStoreSelected = (ev): void => {
    const idStore = ev.target.value
    setStoreSelected(idStore)
    getGraphInfo(idStore)
    getHighLights(idStore)
    triggerSearch({ resetPageNumber: true })
  }

  const cleanUpState = async () => {
    window.history.replaceState(null, '');
  }

  useEffect(() => {
    let cancelled = false
    const load = async () => {
      if (storeId) {
        setStoreSelected(storeId)
        await getStores(storeId)
        if (cancelled) return
        triggerSearch({ resetPageNumber: true })
      } else {
        setStoreSelected(StatisticsStores.ALLSTORES)
        getGraphInfo()
        getHighLights()
        triggerSearch({ resetPageNumber: true })
        await getStores()
      }
    }
    load()
    return () => {
      cancelled = true
      cleanUpState()
    }
  }, [getStores, getHighLights, getGraphInfo, triggerSearch, setStoreSelected, storeId])

  const {isResponsive: isLargeMobile} = useGetIsResponsiveScreen('(max-width: 768px)')

  const dashboardStats = [
    { label: 'Customers', value: statisticsHighlights?.customerCount, dashboard: true 
     },
    { label: 'Stores', value: statisticsHighlights?.storeCount, dashboard: true },
    { label: 'Products', value: statisticsHighlights?.productsSold, dashboard: true },
    { label: 'Orders', value: statisticsHighlights?.orderCount, dashboard: true },
    { label: 'Videos', value: statisticsHighlights?.totalVideo || 0 },
    { label: 'AI Tokens Usage', value: formatNumberShort(statisticsHighlights?.totalGeminiTokens || 0) },
  ].filter(item => !item.dashboard || isDashboard)



  return (
    <PageContainer className={cl(styles.scrollable)}>
      <div className='container'>
        <div className={`d-flex justify-content-between ${isLargeMobile && "flex-column gap-3"}`}>
          <div className='d-flex'>
            <PageHeader
              navSegments={[
                {
                  icon: IconStatistics,
                  label: 'Store statistics'
                }
              ]}
            />
            {!isDashboard && (
              <div className='d-flex'>
                <p className={styles.selectedPeriodText}>Store</p>
                <select id="statistic-stores" onChange={ev => handleStoreSelected(ev)} className={styles.selectPeriod}>
                  <option value={StatisticsStores.ALLSTORES} >{StatisticsStores.ALLSTORES}</option>
                  {storesList && storesList.map((store: StoreDTO) => {
                    if (store.name.includes(storeName)) {
                      return <option key={store.id} value={store.id} selected>{store.name}</option>
                    } return (
                      <option key={store.id} value={store.id}>{store.name}</option>
                    )
                  }
                  )}
                </select>
              </div>
            )}
          </div>
          <div className={`d-flex ${isLargeMobile && "flex-column"}`}>
            <div className='d-flex'>
              <p className={styles.selectedPeriodText}>Period</p>
              <select id="statistic-period" onChange={ev => selectDatePeriod(ev)} className={styles.selectPeriod}>
                <option value={StatisticsDatePeriod.WEEK}>{StatisticsDatePeriod.WEEK}</option>
                <option value={StatisticsDatePeriod.MONTH}>{StatisticsDatePeriod.MONTH}</option>
                <option value={StatisticsDatePeriod.YEAR}>{StatisticsDatePeriod.YEAR}</option>
              </select>
            </div>
            {/* <div className={styles.periodPicker}> */}
            <PeriodPicker
              period={startPeriod
                ? { start: startPeriod, end: endPeriod }
                : null
              }
              setPeriod={period => setPeriod(period ? period : null)}
              dateFormat='DD.MM.YY'
              noIcon
              label=''
              placeholder='Custom'
              className={styles.customFilterComponent}
              style={{zIndex: 5}}
            />
            {/* </div> */}
          </div>
        </div>
        {
          !isDashboard ? (
            <div className={styles.highlightBox}>
              <p>Highlights</p>
              <div className="d-flex justify-content-between flex-wrap">
                <div className={styles.highLightStat}>
                  <h1>${statisticsHighlights?.totalRevenue}</h1>
                  <span>Revenue</span>
                </div>
                <div className={cl(styles.highLightStat, styles.borderLeftHighlights)}>
                  <h1>{statisticsHighlights?.activeProducts}</h1>
                  <span>Active products</span>
                </div>
                <div className={cl(styles.highLightStat, styles.borderLeftHighlights)}>
                  <h1>{statisticsHighlights?.productsSold}</h1>
                  <span>Products sold</span>
                </div>
                <div className={cl(styles.highLightStat, styles.borderLeftHighlights)}>
                  <h1>{statisticsHighlights?.orderCount}</h1>
                  <span>Orders</span>
                </div>
                <div className={cl(styles.highLightStat, styles.borderLeftHighlights)}>
                  <h1>{statisticsHighlights?.storeCount}</h1>
                  <span>Stores</span>
                </div>
                <div className={cl(styles.highLightStat, styles.borderLeftHighlights)}>
                  <h1>{statisticsHighlights?.visitingUsers}</h1>
                  <span>Visiting users</span>
                </div>
              </div>
            </div>
          ) :
            (<div className={styles.highlightBox}>
              <p>Highlights</p>
              <div className="d-flex justify-content-between flex-wrap">
                <div className={styles.highLightStat}>
                  <h1>${statisticsHighlights?.totalRevenue}</h1>
                  <span>Total revenue</span>
                </div>
                <div className={cl(styles.highLightStat, styles.borderLeftHighlights, styles.tooltip)}>
                  <h1>{statisticsHighlights?.bestStore?.name}</h1>
                  <span>Best store</span>
                  <span className={styles.tooltiptext}>
                    <div className='d-flex p-3'>
                      <ImagePortrait width={62} height={86} src={getMainImageSrcForObj(statisticsHighlights?.bestStore)} />
                      <div className={styles.tooltipContent}>
                        <h2>{statisticsHighlights?.bestStore?.name}</h2>
                        <RatingStars rating={3.8} reviewsCnt={762} />
                        <hr />
                        <h2>$8225 revenue</h2>
                      </div>
                    </div>
                  </span>
                </div>
                <div className={cl(styles.highLightStat, styles.borderLeftHighlights)}>
                  <h1>{statisticsHighlights?.productsSold}</h1>
                  <span>Products sold</span>
                </div>
                <div className={cl(styles.highLightStat, styles.borderLeftHighlights, styles.tooltip)}>
                  <h1>{statisticsHighlights?.bestSellingProduct?.name}</h1>
                  <span>Best selling product</span>
                  <span className={styles.tooltipBestSellerStore}>
                    <div className='d-flex p-3'>
                      <ImagePortrait width={70} height={70} src={getMainImageSrcForObj(statisticsHighlights?.bestSellingProduct)} />
                      <div className={styles.tooltipContent}>
                        <h2>{statisticsHighlights?.bestSellingProduct?.name}</h2>
                        <hr />
                        <h2>{statisticsHighlights?.bestSellingProduct?.sold} sold(${statisticsHighlights?.bestSellingProduct?.revenue} revenue)</h2>
                        <span>{statisticsHighlights?.bestSellingProduct?.storeName}</span>
                      </div>
                    </div>
                  </span>
                </div>
                <div className={cl(styles.highLightStat, styles.borderLeftHighlights)}>
                  <h1>{statisticsHighlights?.visitingUsers}</h1>
                  <span>Visiting users</span>
                </div>
              </div>
            </div>
            )
        }
        {
          !!dashboardStats.length && (
            <div className={styles.fourBoxes}>
              {dashboardStats.map((item) => (
                <div key={item.label}>
                  <div className='d-flex'>
                    <IconStores />
                    <h3>{item.label}</h3>
                  </div>
                  <h1>{item.value}</h1>
                </div>
              ))}
            </div>
          )
        }
        <div className={cl(styles.statChartTable, 'mt-4')}>
          <div className='d-flex justify-content-between'>
            <h2>Overview</h2>
            <p className={styles.totalRevenue}>Total revenue for selected period: <span className={styles.totalRevenueValue}>
              ${statisticsGraph &&
                !!statisticsGraph.length ?
                statisticsGraph
                  .map(statInfo => statInfo.revenueToday)
                  .reduce((previousValue, currentValue) =>
                    previousValue + currentValue
                  ) : 0}</span></p>
          </div>
          <div className={styles.periodChartContainer}>
            <p className={styles.productsText}>Products</p>
            {statisticsGraph && <Customchart type='bar' height={100} data={statiSticsGraphData} />}
          </div>
          <div className={styles.periodText}>
            Period
          </div>
          <hr />
          {!isDashboard && <StatisticsTable />}
        </div>
      </div>
    </PageContainer>
  )
}

const StatisticsPage = observer(StatisticsPageComponent)
export { StatisticsPage }
